import React, { useEffect, useState } from 'react'
import Card from './Card'
import useApi from '../../hooks/useApi'
import { network_tl } from '../../translations'
import { customStringify, error_alert, removeToken } from '../../utils'
import Loading from '../../components/Loading'
import RetryApi from '../../components/RetryApi'
import axios from 'axios'
import { FormattedMessage, useIntl } from 'react-intl'
import { AGENCY_INFLUENCER_STORAGE_KEY } from '../../constants'
import { logout } from '../../redux/slices/userSlice'
import { useDispatch, useSelector } from 'react-redux'
import { FiMinusCircle } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import { RxDashboard } from 'react-icons/rx'


const Pricing = ({ renew }) => {


    const { Axios } = useApi();
    const [error, setError] = useState(false);
    const [data, setData] = useState({});
    const intl = useIntl();
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(state => state.user);


    const getData = async () => {
        setLoading(true);
        setError(false);
        try {

            const result = await Axios.get(`api/user/subscription-plans`);
            const plans = result.data.payload;
            
             const freePlan = {
                id: 'free_plan',
                name: 'Piano Gratuito',
                price: 0,
                
               
            };
           

            if(!user?.free_subscription?.is_paid){
                setData([freePlan, ...plans]);

            }else{
                setData(plans);
            }
            
            // setdata(result.data.payload);
            setLoading(false);
        } catch (e) {
            if (axios.isCancel(e)) {

            } else if (e.response) {
                setError(customStringify(e.response.data.description))
            } else {
                setError(network_tl(intl))
            }
            setLoading(false)
        }
    }

    useEffect(() => {
        getData();
    }, []);

    const handleLogout = async () => {
        try {
            // setLoading(true);
            // const result = await Axios.get("api/user/logout");
            dispatch(logout());
            localStorage.removeItem(AGENCY_INFLUENCER_STORAGE_KEY)
            removeToken();
            navigate("/");
            // success_alert(result.data.description);
            setLoading(false);
        } catch (e) {
            setLoading(false);
            if (axios.isCancel(e)) {
            }
            else if (e.response) {
                error_alert(customStringify(e.response.data.description));
            } else {
                error_alert(network_tl(intl));
            }
        }
    }

    return (
        <>
            <div className='flex  bg-white'>

                <div className="hidden lg:flex bg-primary min-h-[100vh]  shadow-2xl  flex-col justify-center  flex-grow py-5 px-5 space-y-8  w-[25%] rounded-r-xl">
                    <img src="/images/logo-white.png" className='w-[150px]' />

                    <h1 className="text-5xl mt-16 text-white font-bold">
                        <FormattedMessage id="pricing" defaultMessage="Pricing" />
                    </h1>


                </div>


                <div className="w-[90%] lg:w-[75%] mx-auto px-4 pt-16 pb-10 md:rounded-[20px]">
                    {loading && !error ? (
                        <Loading />
                    ) : error ? (
                        <RetryApi retry={getData} error={error} />
                    ) : (
                        <div className='container'>
                            <div className='flex justify-between'>
                                <h1 className="text-left text-3xl text-t-light font-bold">
                                    <FormattedMessage id="choose_plan" defaultMessage="Choose Plan" />
                                </h1>
                                
                                   <div className='flex items-center gap-x-2'>
                                   {renew && <button
                                        onClick={() => navigate("/")}
                                        type="button"
                                        className={`w-auto transition-all mb-2 rounded-full hover:bg-primary group hover:-translate-y-1 duration-300  flex space-x-3 py-3 px-4 items-center justify-start`}
                                    >
                                        <RxDashboard className={`transition-all flex-shrink-0 group-hover:text-white text-xl`} />
                                        <span className={`transition-all text-sm font-medium group-hover:text-white `}>
                                            <FormattedMessage id="dashboard" defaultMessage="Dashboard" />
                                        </span>
                                    </button>}
                                   <button
                                        onClick={handleLogout}
                                        type="button"
                                        className={`w-auto transition-all mb-2 rounded-full bg-primary hover:-translate-y-1 duration-300 group flex space-x-3 py-3 px-4 items-center justify-start`}
                                    >
                                        <FiMinusCircle className={`transition-all flex-shrink-0 text-white text-xl`} />
                                        <span className={`transition-all text-sm font-medium text-white `}>
                                            <FormattedMessage id="logout" defaultMessage="Logout" />
                                        </span>
                                    </button> 
                                   
                                   </div>
                            </div>
                            {data.length > 0 ? (
                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 w-full">
                                    {data.map((item, index) => (
                                        <Card key={index} data={item} />
                                    ))}
                                </div>
                            ) : (
                                <p className="text-t-light text-center mt-5 w-full">
                                    <FormattedMessage id="no_plans_available" defaultMessage="No Plans Available" />
                                </p>
                            )}
                        </div>
                    )}
                </div>






            </div>

        </>
    )
}

export default Pricing